import React from 'react';

export default class NotFound extends React.Component {
  // eslint-disable-next-line
  render() {
    return (
      <section>
        <h1>Page Not Found</h1>
        <p>Your page was not found.</p>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js